import { render, staticRenderFns } from "./learning-page-hero.vue?vue&type=template&id=263f2c6f&"
import script from "./learning-page-hero.vue?vue&type=script&lang=js&"
export * from "./learning-page-hero.vue?vue&type=script&lang=js&"
import style0 from "./learning-page-hero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports